import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
`;

const TooltipContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 33px;
  background: #ffffff;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  font-size: 14px;
  animation: ${floatAnimation} 2s ease-in-out infinite;
  border: 1px solid #eaeaea;
  display: flex;
  align-items: center;
  gap: 8px;

  &:after {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 12px;
    height: 12px;
    background: #ffffff;
    border-left: 1px solid #eaeaea;
    border-top: 1px solid #eaeaea;
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  color: #666;
  
  &:hover {
    color: #333;
  }
`;

const TooltipText = styled.span`
  white-space: nowrap;
`;

const AddDockTooltip = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if browser is Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    // Check if app is running in standalone mode (home screen app)
    const isStandalone = window.navigator.standalone;
    
    // Check if tooltip has been dismissed before
    const hasBeenDismissed = localStorage.getItem('AddDockTooltipDismissed');
    
    if (isSafari && !isStandalone && !hasBeenDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('AddDockTooltipDismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <TooltipContainer>
      <TooltipText>Add to dock</TooltipText>
      <CloseButton onClick={handleDismiss}>×</CloseButton>
    </TooltipContainer>
  );
};

export default AddDockTooltip; 